<div class="menu">
  <ul>
    <li>
      <a (click)="goToDashboard()">
        <span class="material-icons-outlined">dashboard</span>
        <span>{{ "menu.dashboard" | translate }}</span>
      </a>
    </li>
    <li>
      <a (click)="goToTicket()">
        <span class="material-icons-outlined">confirmation_number</span>
        <span class="title">{{ "menu.ticket" | translate }}</span>
      </a>
    </li>

    <li>
      <a (click)="goToBranche()">
        <span class="material-icons-outlined">domain</span>
        <span class="icon-label">{{ "menu.branches" | translate }}</span>
      </a>
    </li>
    <li>
      <a (click)="goToDepartments()">
        <span class="material-icons-outlined">apartment</span>
        <span class="icon-label">{{ "menu.departments" | translate }}</span>
      </a>
    </li>
    <li>
      <a (click)="goToUsers()">
        <span class="material-icons-outlined">person</span>
        <span class="title">{{ "menu.users" | translate }}</span>
      </a>
    </li>
    <li>
      <a (click)="goToPriority()">
        <span class="material-icons-outlined">priority_high</span>
        <span class="title">{{ "menu.priority" | translate }}</span>
      </a>
    </li>
    <li>
      <a (click)="goToStatus()">
        <span class="material-icons-outlined">check_circle</span>
        <span class="title">{{ "menu.status" | translate }}</span>
      </a>
    </li>
 
  </ul>
</div>
